// 协同育人layout
<template>
  <div>
    <!-- banner -->
    <div class="second_banner">
      <img :src="bannerImg" :alt="sectionTitle" />

      <div class="div_beard">
        <p>
          <a
            v-for="(bread, index) in breads"
            :key="index"
            @click="$router.push(bread.path)"
          >
            {{ bread.name }}
          </a>
        </p>
      </div>
    </div>

    <!-- tabs -->
    <div class="second_nav">
      <ul>
        <li
          :class="{
            on: activeTabId == tab.id,
          }"
          v-for="tab in navTabs"
          :key="tab.id"
        >
          <a @click="handleRouterPush(tab.path)">
            <span>{{ tab.name }}</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- content -->
    <slot name="desc" />

    <div
      class="container information"
      :class="{ 'pt-0': currentActiveTitle }"
      id="newsAnchor"
    >
      <div class="div_mod div_mod1">
        <!-- <div class="div_tit">
          <h2>{{ currentActiveTitle || activeTitle }}</h2>
        </div> -->

        <slot name="search"></slot>

        <slot name="list" />
        <pre></pre>

        <slot name="pagination" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import portalApi from '../../../../lvya-common/src/api/eos/portal'
import { useAddColumnCount } from '../utils/useAddArticleCount'

export default {
  props: {
    currentActiveTitle: { type: String, default: '' },
    activeId: { type: Number, default: null },
  },
  computed: {
    ...mapState({
      nav: (state) => state.yzsyStore.nav,
    }),
    navTabs() {
      return (
        this.nav
          ?.find((item) => item.code === 'xietongyuren')
          ?.stypes?.map((nav) => ({
            id: nav.id,
            name: nav.title,
            path: nav.tzurl,
          })) || []
      )
    },
    bannerImg() {
      return this.nav?.find((item) => item.code === 'xietongyuren')?.bgimg
    },
    sectionTitle() {
      return this.nav?.find((item) => item.code === 'xietongyuren')?.title
    },
    activeTabId() {
      console.log(this.nav, 'this.navthis.nav')
      return this.activeId
      // return this.navTabs?.find((item) => item.path == this.$route.path)?.id
    },
    activeTitle() {
      return this.navTabs?.find((item) => item.path === this.$route.path)?.name
    },
    breads() {
      const activeNav = this.nav?.find((item) => item.code === 'xietongyuren')
      const activeTab = this.navTabs?.find(
        (item) => item.path === this.$route.path
      )
      return [
        { name: activeNav?.title, path: activeNav?.tzurl },
        { name: activeTab?.name, path: activeTab?.path },
      ]
    },
  },
  watch: {
    activeTabId: {
      async handler(newVal) {
        if (newVal) {
          useAddColumnCount(newVal)
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleRouterPush(path) {
      this.$router.push(path)
    },
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.css";
@import "../style/global.css";
@import "../style/news.css";

/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #007cbc !important;
}
/deep/.el-pagination {
  margin-top: 1rem;
  .btn-next,
  .btn-prev {
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.6rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    border: 1px solid #eaeaea;
    font-size: 0.18rem;
    border-radius: 5px;
    &:not(.disabled):hover {
      background: #007cbc;
      color: #fff;
    }
  }
  .el-pager {
    &li:not(.disabled):hover {
      color: #007cbc !important;
    }
    .more {
      background: transparent;
    }
    .number {
      border-radius: 5px;
      background: transparent;
      :hover {
        color: #007cbc !important;
      }
      &.active {
        background-color: #007cbc !important;
      }
    }
  }
}
  .second_nav ul li.on span {
      color: #007cbc;
  }
  .second_nav ul li.on::after{
    border-top: 6px solid #007cbc
  }
  .second_nav ul li.on {
    border-bottom: 2px solid #007cbc;
}
.container{
  padding-top: 0.8rem;
}
</style>
